/* global axios */
import ApiClient from '../ApiClient';

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, wgpt: true });
  }

  getCampaign(campaignId) {
    return axios.get(`${this.url}/campaign/${campaignId}`);
  }
}

export default new ReportsAPI();
